export default "__VITE_ASSET__DdwiNgKK__"